import { render } from "./ReplyPoints.vue?vue&type=template&id=e625a496&scoped=true"
import script from "./ReplyPoints.vue?vue&type=script&lang=js"
export * from "./ReplyPoints.vue?vue&type=script&lang=js"

import "./ReplyPoints.vue?vue&type=style&index=0&id=e625a496&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e625a496"]])

export default __exports__